import React, { useState } from 'react';

import { Col, Dropdown, Modal, Row } from 'react-bootstrap';
import '../JobStageSummary.scss';
import { CustomButton } from '../../../_common/CustomButton/CustomButton';
import {
    GetWellheadsByStageGroupId_getWellheadsByStageGroupId as StageWellheads,
    GetJobLogs_getJobLogs_details as JobLogDetailsType,
    GetJobLogMetaData_getJobLogMetaData_types as JobLogTypesType,
    GetJobLogMetaData_getJobLogMetaData_issues as JobLogIssueType,
    GetStages_getStages as StageNumberType,
    GetJobLogMetaData_getJobLogMetaData_rootcauses as JobLogRootCauseType,
    GetJobLogMetaData_getJobLogMetaData_locationLOFAs as JobLogLocationLofaType,
} from '../../../../types/schemaTypes';
import { Loading } from '../../../_common/Loading/Loading';

interface PauseStageModalProps {
    showPauseStageModal: boolean;
    stageStatusData: any | undefined;
    jobLogsTypesData: JobLogTypesType[];
    jobLogIssues: JobLogIssueType[];
    jobLogRootCauses: JobLogRootCauseType[];
    jobLogLocationLofa: JobLogLocationLofaType[];
    handleOnClose: (modalType) => void;
    handleOnSave: (
        jobStageIds,
        jobLogId: any,
        jobLogIssueId: any,
        jobLogTypeId: any,
        startDate: any,
        endDate: any,
        estimatedDowntime: any,
        loadId: any,
        notes: any,
        locationLofa: any,
        amount: any,
        rootCauseId: any,
        correctiveAction: any,
    ) => void;
    mutationLoading: boolean;
    mutationError: string | undefined;
}

const PauseStageModal = ({
    showPauseStageModal,
    stageStatusData,
    jobLogsTypesData,
    jobLogIssues,
    jobLogRootCauses,
    jobLogLocationLofa,
    handleOnClose,
    handleOnSave,
    mutationLoading,
    mutationError,
}: PauseStageModalProps): React.ReactElement => {
    const [wellheadStage, setWellheadStage] = useState<string>();
    const [jobStageIds, setJobStageIds] = useState<number[]>();

    const [logType, setLogType] = useState('');
    const [logTypeId, setLogTypeId] = useState(null);
    const [issueType, setIssueType] = useState('');
    const [issueTypeId, setIssueTypeId] = useState<number | null>(null);
    const [downtime, setDowntime] = useState<number | null>(null);
    const [loadId, setLoadId] = useState<number | null>(null);
    const [lofa, setLofa] = useState<string | null>('');
    const [lofaId, setLofaId] = useState<number | null>(null);
    const [amount, setAmount] = useState<number | null>(null);
    const [rootCause, setRootCause] = useState<string | null>('');
    const [rootCauseId, setRootCauseId] = useState<number | null>(null);
    const [notes, setNotes] = useState<string | null>('');
    const [correctiveAction, setCorrectiveAction] = useState<string | null>('');

    const [endDateError, setEndDateError] = useState('');
    const [downTimeError, setDownTimeError] = useState('');
    const [stageError, setStageError] = useState('');
    const [loadIdError, setLoadIdError] = useState('');
    const [amountError, setAmountError] = useState('');
    const [notesError, setNotesError] = useState('');

    const logIssueList: JobLogIssueType[] = [];
    jobLogIssues.map(issue => {
        if (issue.jobLogTypeId === logTypeId) {
            logIssueList.push(issue);
        }
    });
    logIssueList.sort((a, b) => {
        let fa = '';
        let fb = '';
        if (a.descrip && b.descrip) {
            fa = a.descrip.toLowerCase();
            fb = b.descrip.toLowerCase();
        }
        if (fa < fb) {
            return -1;
        }
        if (fa > fb) {
            return 1;
        }
        return 0;
    });

    const wellheadStageList = stageStatusData.stageStatus.filter(wellheadStageItem => {
        if (wellheadStageItem.status === 'Running') return true;
        else return false;
    });

    const handleOnChangeWellheadStage = (wellhead: string, jobStageId: number) => {
        if (wellhead === 'ALL') {
            const tempJobStageIds: number[] = [];
            wellheadStageList.map(WellheadStageItem => {
                tempJobStageIds.push(WellheadStageItem.stageId);
            });
            setWellheadStage('Select All');
            setJobStageIds(tempJobStageIds);
        } else {
            setWellheadStage(`${wellhead}`);
            setJobStageIds([jobStageId]);
        }
    };

    const onChangeLogType = (logId, logType) => {
        setLogTypeId(logId);
        setLogType(logType);

        if (logTypeId !== logId) {
            setIssueTypeId(null);
            setIssueType('');
        }

        if (logId === 6) {
            setIssueTypeId(-1);
            setIssueType('');
        }
    };

    const onChangeIssue = (issueTypeId, issueType) => {
        setIssueTypeId(issueTypeId);
        setIssueType(issueType);
    };

    const onChangeDowntime = event => {
        setDownTimeError('');
        if (Number.isNaN(event.target.value)) setDowntime(null);
        else setDowntime(parseInt(event.target.value));
    };

    const onChangeLoadId = event => {
        setLoadIdError('');
        if (Number.isNaN(event.target.value)) setLoadId(null);
        else setLoadId(parseInt(event.target.value));
    };

    const onChangeLofa = (lofaId, lofa) => {
        setLofaId(lofaId);
        setLofa(lofa);
    };

    const onChangeAmount = event => {
        setAmountError('');
        if (Number.isNaN(event.target.value)) setAmount(null);
        else setAmount(parseInt(event.target.value));
    };

    const onChangeRootCause = (rootCauseId, rootCause) => {
        setRootCauseId(rootCauseId);
        setRootCause(rootCause);
    };

    const onChangeCorrectiveAction = event => {
        setCorrectiveAction(event.target.value);
    };

    const onChangeNotes = event => {
        setNotesError('');
        setNotes(event.target.value);
    };

    const onClickSave = () => {
        let isSaveEnabled = true;

        if (downtime && downtime < 0) {
            isSaveEnabled = false;
            setDownTimeError('Enter a vaild number');
        }

        if (loadId && loadId < 0) {
            isSaveEnabled = false;
            setLoadIdError('Enter a vaild Load Id');
        }

        if (amount && amount < 0) {
            isSaveEnabled = false;
            setAmountError('Enter a vaild Amount');
        }

        if (notes && notes.length > 2000) {
            isSaveEnabled = false;
            setNotesError('Notes cannot be more than 2000 character');
        }

        if (isSaveEnabled)
            handleOnSave(
                jobStageIds,
                -1,
                logTypeId,
                issueTypeId,
                new Date(),
                null,
                downtime,
                loadId,
                notes,
                lofa,
                amount,
                rootCauseId,
                correctiveAction,
            );
    };

    const setContinueButtonStatus = (): boolean => {
        if (jobStageIds?.length === 0 || !logTypeId || (logTypeId !== 6 && !issueTypeId) || mutationLoading) {
            return true;
        }
        if (mutationError === undefined || mutationError === '') {
            return false;
        } else {
            return true;
        }
    };

    const onClickClose = () => {
        handleOnClose('pauseStage');
    };

    if (wellheadStageList.length === 1 && !wellheadStage) {
        handleOnChangeWellheadStage(wellheadStageList[0].wellHead, wellheadStageList[0].stageId);
    }
    if (wellheadStageList.length > 1 && !wellheadStage) {
        handleOnChangeWellheadStage('ALL', 0);
    }

    return (
        <Modal show={showPauseStageModal} onHide={onClickClose} dialogClassName="Pause-Modal-Container">
            {mutationLoading && (
                <span className="AddStageModal-Loading">
                    <Loading />
                </span>
            )}

            <Modal.Header className="AddStageModal-Header">
                <Modal.Title className="AddStageModal-Header-Container">
                    <button className="material-icons AddStageModal-X-Button" onClick={onClickClose}>
                        close
                    </button>
                    <div className="AddStageModal-Title">Pause Stage</div>
                    <div className="AddStageModal-Error">{mutationError}</div>
                </Modal.Title>
            </Modal.Header>

            <Modal.Body className="Pause-Modal-Body">
                <div>Select a Wellhead-Stage below and click continue to proceed</div>

                <Row>
                    <Col md={5}>
                        <Dropdown>
                            <Dropdown.Toggle
                                variant="outline-dark"
                                id="dropdown-basic"
                                className="EndStage-wellheadStage"
                            >
                                <span>{wellheadStage}</span>
                            </Dropdown.Toggle>
                            <Dropdown.Menu>
                                {wellheadStageList.length > 1 && (
                                    <Dropdown.Item 
                                   // onSelect={() => handleOnChangeWellheadStage('ALL', 0)}
                                   onClick={() => handleOnChangeWellheadStage('ALL', 0)}
                                    >
                                        Select All
                                    </Dropdown.Item>
                                )}
                                {wellheadStageList.map((wellheadStageItem, index) => (
                                    <Dropdown.Item
                                        key={index}
                                        // onSelect={() =>
                                        //     handleOnChangeWellheadStage(
                                        //         wellheadStageItem.wellHead,
                                        //         wellheadStageItem.stageId,
                                        //     )
                                        // }
                                        onClick={() =>
                                            handleOnChangeWellheadStage(
                                                wellheadStageItem.wellHead,
                                                wellheadStageItem.stageId,
                                            )
                                        }
                                    >
                                        {wellheadStageItem.wellHead}
                                    </Dropdown.Item>
                                ))}
                            </Dropdown.Menu>
                        </Dropdown>
                    </Col>
                </Row>

                <Row className="Pause-Modal-Row-Container">
                    <Col md={5}>
                        <label className="Pause-Modal-Label">*Job Log Type</label>
                        <Dropdown className="Pause-Modal-Dropdown">
                            <Dropdown.Toggle variant="outline-dark" id="JobLogs-Details-Filter">
                                <span>{logType === '' ? 'Job Log Type' : logType}</span>
                            </Dropdown.Toggle>
                            <Dropdown.Menu>
                                {jobLogsTypesData.map((jobLogType, index) => {
                                    if ([1, 3, 6].includes(jobLogType.id ?? 0))
                                        return (
                                            <Dropdown.Item
                                                key={index}
                                                onClick={() => onChangeLogType(jobLogType.id, jobLogType.descrip)}
                                            >
                                                {jobLogType.descrip}
                                            </Dropdown.Item>
                                        );
                                })}
                            </Dropdown.Menu>
                        </Dropdown>
                    </Col>
                    {logTypeId !== 6 ? (
                        <Col md={5}>
                            <label className="Pause-Modal-Label">*Job Log Issue</label>
                            <Dropdown className="Pause-Modal-Dropdown">
                                <Dropdown.Toggle variant="outline-dark" id="JobLogs-Details-Filter">
                                    <span>{issueType === '' ? 'Issue' : issueType}</span>
                                </Dropdown.Toggle>
                                <Dropdown.Menu>
                                    {logIssueList.map((jobLogIssues, index) => (
                                        <Dropdown.Item
                                            key={index}
                                            onClick={() =>
                                                onChangeIssue(jobLogIssues.jobLogIssueId, jobLogIssues.descrip)
                                            }
                                        >
                                            {jobLogIssues.descrip}
                                        </Dropdown.Item>
                                    ))}
                                </Dropdown.Menu>
                            </Dropdown>
                        </Col>
                    ) : (
                        <></>
                    )}
                </Row>

                {[1, 2, 3, 6].includes(logTypeId ?? 0) ? (
                    <Row className="Pause-Modal-Row-Container">
                        <Col md={5}>
                            <div className="Pause-Modal-Input-Container">
                                <label className="Pause-Modal-Label">Estimated Downtime (in minutes)</label>
                                <input
                                    type="number"
                                    className="Pause-Modal-Input"
                                    value={downtime ?? ''}
                                    onChange={event => onChangeDowntime(event)}
                                />
                                <span className="Pause-Modal-Error">{downTimeError}</span>
                            </div>
                        </Col>
                    </Row>
                ) : (
                    <></>
                )}

                {logTypeId === 4 ? (
                    <>
                        <Row className="Pause-Modal-Row-Container">
                            <Col md={5}>
                                <div className="Pause-Modal-Input-Container">
                                    <label className="Pause-Modal-Label">Load ID</label>
                                    <input
                                        type="number"
                                        className="Pause-Modal-Input"
                                        value={loadId ?? ''}
                                        onChange={event => onChangeLoadId(event)}
                                    />
                                    <span className="Pause-Modal-Error">{loadIdError}</span>
                                </div>
                            </Col>
                            <Col md={5}>
                                <Dropdown className="Pause-Modal-Dropdown">
                                    <Dropdown.Toggle variant="outline-dark" id="JobLogs-Details-Filter">
                                        <span>{lofa === '' ? 'Lofa/ Location' : lofa}</span>
                                    </Dropdown.Toggle>
                                    <Dropdown.Menu>
                                        <Dropdown.Item onClick={() => onChangeLofa(null, '')}>None</Dropdown.Item>
                                        {jobLogLocationLofa.map((locationLofa, index) => (
                                            <Dropdown.Item
                                                key={index}
                                                onClick={() => onChangeLofa(locationLofa.id, locationLofa.descrip)}
                                            >
                                                {locationLofa.descrip}
                                            </Dropdown.Item>
                                        ))}
                                    </Dropdown.Menu>
                                </Dropdown>
                            </Col>
                        </Row>

                        <Row className="Pause-Modal-Row-Container">
                            <Col md={5}>
                                <div className="Pause-Modal-Input-Container">
                                    <label className="Pause-Modal-Label">Amount</label>
                                    <input
                                        type="number"
                                        className="Pause-Modal-Input"
                                        value={amount ?? ''}
                                        onChange={event => onChangeAmount(event)}
                                    />
                                    <span className="Pause-Modal-Error">{amountError}</span>
                                </div>
                            </Col>
                            <Col md={5}>
                                <Dropdown className="Pause-Modal-Dropdown">
                                    <Dropdown.Toggle variant="outline-dark" id="JobLogs-Details-Filter">
                                        <span>{rootCause === '' ? 'Root Cause' : rootCause}</span>
                                    </Dropdown.Toggle>
                                    <Dropdown.Menu>
                                        <Dropdown.Item onClick={() => onChangeRootCause(null, '')}>None</Dropdown.Item>
                                        {jobLogRootCauses.map((rootCause, index) => (
                                            <Dropdown.Item
                                                key={index}
                                                onClick={() => onChangeRootCause(rootCause.id, rootCause.descrip)}
                                            >
                                                {rootCause.descrip}
                                            </Dropdown.Item>
                                        ))}
                                    </Dropdown.Menu>
                                </Dropdown>
                            </Col>
                        </Row>

                        <Row className="Pause-Modal-Row-Container">
                            <Col md={10}>
                                <div className="Pause-Modal-Input-Container">
                                    <label className="Pause-Modal-Label">Corrective Action</label>
                                    <input
                                        type="text"
                                        className="Pause-Modal-Input"
                                        value={correctiveAction ?? ''}
                                        onChange={event => onChangeCorrectiveAction(event)}
                                    />
                                </div>
                            </Col>
                        </Row>
                    </>
                ) : (
                    <></>
                )}

                <Row className="Pause-Modal-Row-Container">
                    <Col md={10}>
                        <div className="Pause-Modal-Input-Container">
                            <label className="Pause-Modal-Label">Notes</label>
                            <input
                                type="text"
                                className="Pause-Modal-Input"
                                value={notes ?? ''}
                                onChange={event => onChangeNotes(event)}
                            />
                            <span className="Pause-Modal-Error">{notesError}</span>
                        </div>
                    </Col>
                </Row>
            </Modal.Body>

            <Modal.Footer className="AddStageModal-Footer">
                <CustomButton title="Cancel" isBordered onClick={onClickClose} />
                <CustomButton title="Continue" isDisabled={setContinueButtonStatus()} onClick={() => onClickSave()} />
            </Modal.Footer>
        </Modal>
    );
};

export default PauseStageModal;
